import { render, staticRenderFns } from "./Jinterview.vue?vue&type=template&id=6febadc2"
import script from "./Jinterview.vue?vue&type=script&lang=js"
export * from "./Jinterview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports